<template>

  <video v-if="show_mobile_video" id="animation-video" src="https://storage.googleapis.com/outside-voice-a1d45.appspot.com/whatsapp-animation2.mp4" autoplay playsinline muted loop></video>

  <div v-else class="outer-container">
    <div class="message-container" :class="animation_stage">
      <div class="message-inner-container">
        <img class="messages" src="../../assets/landing-animation/message-thread.png"/>
        <video id="video-1" src="https://storage.googleapis.com/outside-voice-a1d45.appspot.com/message-video-1.mp4" autoplay playsinline muted loop></video>
        <video id="video-2" src="https://storage.googleapis.com/outside-voice-a1d45.appspot.com/message-video-2.mp4" autoplay playsinline muted loop></video>
      </div>
    </div>

  </div>
</template>

<script>

import _ from 'lodash';
import { isMobile, isMobileOnly } from 'mobile-device-detect';

export default {
  name: 'Animation',
  data: function () {
    return {
      animation_stage: '',
      show_mobile_video: isMobileOnly
    }
  },
  computed: {},
  methods: {},

  async mounted() {

    // Total of 29 seconds of animation.

    await sleep(500);
    this.animation_stage = 'stage1'; // Ask first video question
    await sleep(2000);
    this.animation_stage = 'stage2'; // Show first video answer
    await sleep(4000);
    this.animation_stage = 'stage3'; // Ask multi-choice question
    await sleep(2500);
    this.animation_stage = 'stage4'; // Show multi-choice answer
    await sleep(3000);
    this.animation_stage = 'stage5'; // Ask audio question
    await sleep(4500);
    this.animation_stage = 'stage6'; // Show audio answer
    await sleep(3500);
    this.animation_stage = 'stage7'; // Ask second video question
    await sleep(4500);
    this.animation_stage = 'stage8'; // Show second video answer
    await sleep(4500);
    this.animation_stage = 'stage9'; // Thank You

    // Restart animation loop

    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    };
  }

}
</script>

<style scoped lang="scss">

.outer-container{
  position: relative;
  width: 95%;
  height: 650px;
  float: right;
  margin-top: 50px;
  overflow: hidden;
  .message-container{
    position: absolute;
      top: 650px;
      left: 0px;
    width: 100%;
    height: auto;
    transition: all 0.3s ease;
    &.stage1{
      transform: translateY(-130px); // Ask Video #1
    }
    &.stage2{
      transform: translateY(-450px); // Answer Video #1
    }
    &.stage3{
      transform: translateY(-660px); // Ask Multi-Choice
    }
    &.stage4{
      transform: translateY(-750px); // Answer Multi-Choice
    }
    &.stage5{
      transform: translateY(-910px); // Ask Audio
    }
    &.stage6{
      transform: translateY(-1000px); // Answer Audio
    }
    &.stage7{
      transform: translateY(-1150px); // Ask Video #2
    }
    &.stage8{
      transform: translateY(-1480px); // Answer Video #2
    }
    &.stage9{
      transform: translateY(-1610px); // Thank you message
    }
    .message-inner-container{
      position: relative;
      width: 100%;
      img{
        position: absolute;
          top: 0px;
          left: 0px;
        width: 100%;
      }
      video{
        position: absolute;
          left: 0px;
        width: 46%;
        border-radius: 10px;
        &#video-1{
          top: 160px;
        }
        &#video-2{
          top: 1165px;
        }
      }
    }
  }
}


// Just show a video instead of full animation on mobile.
#animation-video{
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  height: 400px;
}


/* Mobile Styles (iPhone 6, 7, 8) */
@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {

#animation-video{
  height: 400px;
}

}



/* Mobile Styles (iPhone 6, 7, 8) PLUS */
@media only screen
    and (min-device-width : 414px)
    and (max-device-width : 736px)
    and (device-width : 414px)
    and (device-height : 736px)
    and (orientation : portrait)
    and (-webkit-min-device-pixel-ratio : 3)
    and (-webkit-device-pixel-ratio : 3) {

#animation-video{
  height: 420px;
}

}



/* Mobile Styles (iPhone X) */
@media only screen and (min-device-width: 375px) and (min-device-height: 812px) and (-webkit-device-pixel-ratio: 3) {

#animation-video{
  height: 400px;
}

}


/* Mobile Styles (Pixel 2XL) */
@media screen
  and (min-device-width: 410px)
  and (max-device-width: 412px)
  and (min-device-height: 822px)
  and (max-device-height: 824px)
  and (-webkit-device-pixel-ratio: 3.5)
  and (orientation: portrait) {

#animation-video{
  height: 395px;
}

}



/* IPad Portrait */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {

#animation-video{
  //height: 285px;
}

}

</style>
